import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import { SignalStep } from '../signal-step'
import './style.scss'

export function ModemReset() {
  const dispatch = useDispatch()

  function handleNextClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_AWAIT))
  }

  return (
    <div className='modem-reset'>
      <SignalInfo
        icon={STATICS.MODEM_RESTART}
        iconAlt='Icone de modem reiniciando'
        title='Reiniciar modem'
      >
        <p>Para reiniciar seu modem, vamos fazer um passo a passo.</p>
        <p>Mas não se preocupe, é simples e rápido:</p>
        <SignalStep number={1} description='Desconecte os cabos de alimentação do seu modem.' />
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleNextClick}>
          Pronto, desconectei
        </Button>
      </div>
    </div>
  )
}
